export var MemberRoleEnum;
(function (MemberRoleEnum) {
    MemberRoleEnum["ADMIN"] = "org:admin";
    MemberRoleEnum["OWNER"] = "org:owner";
    MemberRoleEnum["AUTHOR"] = "org:author";
    MemberRoleEnum["VIEWER"] = "org:viewer";
    /**
     * Client integrator on a self-hosted instance run for another company: manages workflows,
     * reads logs and API keys, but cannot change or read provider credentials.
     */
    MemberRoleEnum["INTEGRATOR"] = "org:integrator";
    /**
     * @deprecated member is used only in OSS
     */
    MemberRoleEnum["OSS_MEMBER"] = "member";
    /**
     * @deprecated admin is used only in OSS
     */
    MemberRoleEnum["OSS_ADMIN"] = "admin";
})(MemberRoleEnum || (MemberRoleEnum = {}));
//# sourceMappingURL=member.enum.js.map